import { render, staticRenderFns } from "./TodaysQAAndOfferGenerationTotal.vue?vue&type=template&id=2b792eca&scoped=true&"
import script from "./TodaysQAAndOfferGenerationTotal.vue?vue&type=script&lang=js&"
export * from "./TodaysQAAndOfferGenerationTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b792eca",
  null
  
)

export default component.exports